<template>
    <div class="c-line-clamp" :class="{ '-clamp-needed' : clampNeeded }" :style="'--height:' + clampHeight + 'px'">
        <div class="c-line-clamp__text" :class="{ '-expanded': expanded }" ref="content">
            <div ref="contentContainer" c-line-clamp="c-line-clamp__text-wrapper">
                <slot>

                </slot>
            </div>
        </div>
        <input type="checkbox" :id="id" v-model="expanded" class="state" />
        <label :for="id" class="e-link c-line-clamp__toggle">
            {{ text }}
        </label>
    </div>
</template>

<script>

export default {
    name: 'line-clamp',
    props: {
        lines: {
            type: Number,
            default: 10,
        },
        lineHeight: {
            type: Number,
            default: 28,
        },
        readMore: {
            type: String,
        },
        readLess: {
            type: String,
        },
    },
    data() {
        const id = 'id-' + Math.floor(Math.random() * 10000);
        return {
            id: id,
            expanded: false,
            clampNeeded: false,
        }
    },
    computed: {
        text() {
            if (this.expanded) {
                return this.readLess;
            }
            return this.readMore;
        },
        maxHeight() {
            return this.lines * this.lineHeight;
        },
        clampHeight() {
            return this.expanded ? this.$refs.contentContainer.getBoundingClientRect().height : this.maxHeight;
        },
    },
    mounted() {
        this.$nextTick(() => {
            const h = this.$refs.content.clientHeight;
            if (h > this.maxHeight) {
                this.clampNeeded = true;
            }
        });
    },
}
</script>

